// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'

import axios from 'axios'
import echarts from 'echarts'
import 'echarts/map/js/china.js'
import Wrap from './components/base/Wrap'
import utils from './utils'
import './assets/css/element-variables.scss'
import store from './store'
// import 'babel-polyfill'

import '../static/utf8-php/ueditor.config.js'
import '../static/utf8-php/ueditor.all.min.js'
import '../static/utf8-php/lang/zh-cn/zh-cn.js'
import '../static/utf8-php/ueditor.parse.min.js'
// import 'default-passive-events' //Chrome51 版本以后，Chrome 增加了新的事件捕获机制－Passive Event Listeners
import 'ie-placeholder'   //解决ie9下placeholder不显示问题


Vue.use(ElementUI)
Vue.config.productionTip = false
axios.defaults.baseURL = '/index.php'
// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    let docu = document.querySelectorAll('.Loading__bar___21yOt')
    docu[0].style.transition = 'width .35s';

    docu[0].style.width = '10%';
    return config
}, function (error) {
    // Do something with request error
    return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
    if (response.status === 200) {
        let docu = document.querySelectorAll('.Loading__bar___21yOt')
        docu[0].style.width = '100%';
        setTimeout(() => {
            docu[0].style.transition = 'width 0s';
            docu[0].style.width = '0%';
        }, 1000);
    }
    if (response.status === 203) {
        store.commit('pagePassValue/func_setRelogin', true)
        if (document.getElementsByClassName('el-notification').length === 0) {
            Vue.prototype.$notify({ title: '警告', message: '登陆超时', position: 'top-left', type: 'warning' })
            if (document.getElementsByClassName('el-notification').length === 1) {
                router.push('/')
            }
        }
    }
    return response
}, function (error) {
    switch (error.response.status) {
        case 500:
            if (document.getElementsByClassName('el-notification').length === 0) {
                Vue.prototype.$notify.error({ title: '错误', message: '网络错误!', position: 'top-left' })
            }
        case 401:
            if (document.getElementsByClassName('el-notification').length === 0) {
                Vue.prototype.$notify.error({ title: '错误', message: '你没有权限!', position: 'top-left' })
            }
    }
    return Promise.reject(error)
});
// router.beforeEach((to, from, next) => {
//     let targetProtocol = "https:";
// if (window.location.protocol !== targetProtocol){
//     window.location.href = targetProtocol +
//         window.location.href.substring(window.location.protocol.length);
// }
//
// next();
// });


Vue.prototype.$utils = utils
Vue.prototype.$ajax = axios
Vue.prototype.$echarts = echarts

Vue.prototype.$bus = new Vue() // 空的实例放到根组件下，所有的子组件都能调用

export default new Vue({
    el: '#body',
    router,
    store,
    template: '<App />',
    components: { App, ...Wrap },
    data: {
        Bus: new Vue() // 空的实例放到根组件下，所有的子组件都能调用
    }
})



// WEBPACK FOOTER //
// ./src/main.js